module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funding-goal"
  }, [_c('div', {
    staticClass: "target"
  }, [_c('div', {
    staticClass: "-label"
  }, [_vm._v("เป้าหมาย")]), _vm._v(" "), _c('span', {
    staticClass: "-value"
  }, [_vm._v(_vm._s(_vm._f("comma")(_vm.target)) + " บาท")])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('span', {
    staticClass: "percent -value"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("สำเร็จแล้ว")]), _vm._v(" " + _vm._s(_vm.percent) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar",
    style: ({
      width: (_vm.percent + "%")
    }),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.percent,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), (_vm.remaining > 0) ? _c('span', {
    staticClass: "-label"
  }, [_vm._v("เหลือเวลาอีก " + _vm._s(_vm.remaining) + " วัน")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77835d82","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FundingGoal.vue
// module id = 1197
// module chunks = 0